const toPersianDigits = (str: string | number) => {
    return str.toString().replace(/\d/g, (d) => "۰۱۲۳۴۵۶۷۸۹"[Number(d)]);
};

export function formatRelativeDate(date: string | Date): string {
    const now = new Date();
    const d = typeof date === "string" ? new Date(date) : date;

    const diffMs = now.getTime() - d.getTime();

    const diffSeconds = Math.floor(diffMs / 1000);
    const diffMinutes = Math.floor(diffSeconds / 60);
    const diffHours = Math.floor(diffMinutes / 60);
    const diffDays = Math.floor(diffHours / 24);
    const diffMonths = Math.floor(diffDays / 30);
    const diffYears = Math.floor(diffDays / 365);

    if (diffDays === 0) return "امروز";
    if (diffDays === 1) return "دیروز";
    if (diffDays === 2) return "پریروز";

    if (diffDays < 7) return `${toPersianDigits(diffDays)} روز پیش`;
    if (diffDays < 30) return `${toPersianDigits(Math.floor(diffDays / 7))} هفته پیش`;
    if (diffMonths < 12) return `${toPersianDigits(diffMonths)} ماه پیش`;

    return `${toPersianDigits(diffYears)} سال پیش`;
}